const FIMG = {
  fresh: "/images/products/Global_Fresh.jpeg",
  kesariya: "/images/products/MKF_kesariya.jpeg",
  kesariyagulab: "/images/products/MKF_kesariya-gulab.jpeg",
  kesariyachampa: "/images/products/MKF_kesariya-champa.jpeg",
  kesariyamogra: "/images/products/MKF_kesariya-mogra.jpeg",
  phool: "/images/products/Bella_Phool.jpeg",
  feel: "/images/products/MKF_feel.jpeg",
  kasturi: "/images/products/SKF_kasturi-amber.jpeg",
  kasturichandan: "/images/products/SKF_kasturi-chandan.jpeg",
  desi: "/images/products/Global_Desi-darshan.jpeg",
  kesari: "/images/products/SK_Kesari-phool.jpeg",
  floral: "/images/products/Floral_Festive.jpeg",
};

const FAMILY = {
  fresh: { profile: ["Floral", "Sweet", "Romantic"], note: "the soft, romantic bloom of fresh roses" },
  kesariya: { profile: ["Floral", "Fresh", "Delicate"], note: "the delicate night-blooming sweetness of jasmine" },
  kesariyagulab: { profile: ["Floral", "Sweet", "Romantic"], note: "the sweet, romantic bloom of gulab" },
  kesariyachampa: { profile: ["Floral", "Sweet", "Romantic"], note: "the sweet, romantic bloom of gulab" },
  kesariyamogra: { profile: ["Floral", "Sweet", "Romantic"], note: "the sweet, romantic bloom of gulab" },
  phool: { profile: ["Herbal", "Calm", "Soothing"], note: "the calming, herbal serenity of lavender" },
  feel: { profile: ["Woody", "Deep", "Resinous"], note: "the deep, resinous richness of oud and temple resins" },
  kasturi: { profile: ["Sweet", "Creamy", "Cozy"], note: "the warm, comforting sweetness of vanilla" },
  kasturichandan: { profile: ["Sweet", "Creamy", "Cozy"], note: "the warm, comforting sweetness of vanilla" },
  kesari: { profile: ["Fresh", "Zesty", "Bright"], note: "the bright, uplifting zest of citrus and greens" },
  lavender: { profile: ["Spicy", "Warm", "Rich"], note: "the warm, layered depth of Indian spices" },
  floral: { profile: ["Floral", "Vibrant", "Festive"], note: "a vibrant bouquet of seasonal blooms" },
  desi: { profile: ["Musky", "Soft", "Sensual"], note: "the soft, lingering warmth of musk and amber" },
};

const CAT_META = {
  Economy: { packSize: "Pack of 12 sticks", label: "Economy Collection" },
  Premium: { packSize: "Pack of 20 sticks", label: "Premium Collection" },
  Assorted: { packSize: "Assorted pouch · 60 sticks", label: "Assorted Pouches" },
};

// [name, family, category]
const RAW = [
  ["Fresh", "fresh", "Economy"],
  ["Kesariya 3 in 1", "kesariya", "Premium"],
  ["Bella Phool", "phool", "Economy"],
  ["Feel", "feel", "Economy"],
  ["Kasturi Amber", "kasturi", "Premium"],
  ["Desi Darshan", "desi", "Premium"],
  ["Kesariya Gulab", "kesariyagulab", "Premium"],
  ["Kasturi Chandan", "kasturichandan", "Premium"],
  ["Kesariya Champa", "kesariyachampa", "Premium"],
  ["Kesari Phool", "kesari", "Premium"],
  ["Kesariya Mogra", "kesariyamogra", "Premium"],
];

const slugify = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

export const PRODUCTS = RAW.map(([name, family, category], i) => {
  const fam = FAMILY[family];
  const cat = CAT_META[category];
  return {
    id: slugify(name),
    code: `SK-${String(i + 1).padStart(3, "0")}`,
    name,
    family,
    category,
    categoryLabel: cat.label,
    image: FIMG[family],
    profile: fam.profile,
    descriptor: fam.profile.join(" · "),
    short: `A ${fam.profile[0].toLowerCase()} fragrance inspired by ${fam.note}.`,
    long: `${name} captures ${fam.note}. Blended with over four decades of SK Fragrances craftsmanship, it is designed to create a calm, welcoming atmosphere across homes, prayer spaces and everyday surroundings — a fragrance worth remembering.`,
    type: "Incense Sticks",
    origin: "Bangalore, India",
    packSize: cat.packSize,
    burnTime: "Approx. 30 minutes",
  };
});

export const CATEGORIES = [
  {
    key: "Economy",
    number: "01",
    title: "Economy",
    tagline: "Everyday fragrances. Made for every moment.",
    count: PRODUCTS.filter((p) => p.category === "Economy").length,
    image: "https://static.prod-images.emergentagent.com/jobs/b3e0a1e1-0366-4851-88cb-76192dc2c27f/images/9e83f556cc93b92b7660ff8eea35c791fb6f081a04f08d3d1f00324677af9d28.jpeg",
  },
  {
    key: "Premium",
    number: "02",
    title: "Premium",
    tagline: "Refined aromas. Crafted for elevated spaces.",
    count: PRODUCTS.filter((p) => p.category === "Premium").length,
    image: "https://static.prod-images.emergentagent.com/jobs/b3e0a1e1-0366-4851-88cb-76192dc2c27f/images/6dfed1404feb6165a8222186b87946c4547fa6a39d65302374c60f4f7843ede2.jpeg",
  },
  {
    key: "Assorted",
    number: "03",
    title: "Assorted Pouches",
    tagline: "A collection of aromas. One beautiful experience.",
    count: PRODUCTS.filter((p) => p.category === "Assorted").length,
    image: "https://static.prod-images.emergentagent.com/jobs/b3e0a1e1-0366-4851-88cb-76192dc2c27f/images/d9610980d12020a6a47e49fbca9f0903de6200a49764bc988bd3434794fed5dc.jpeg",
  },
];

export const getProduct = (id) => PRODUCTS.find((p) => p.id === id);
